import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import type React from "react";
import { Link } from "react-router";
import { HEADER_HEIGHT } from "@/config/constants";
import { UserMenu } from "./utilities/UserMenu";

export function Header(): React.ReactElement {
	return (
		<AppBar
			component={"header"}
			sx={{
				gridArea: "header",
				height: HEADER_HEIGHT,
				boxShadow: "none",
			}}
		>
			<Toolbar sx={{ justifyContent: "space-between" }}>
				<Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
					<Button component={Link} to="/" sx={{ color: "#FFFFFF" }}>
						<Typography
							variant="h6"
							noWrap
							component="div"
							sx={{
								flexGrow: 1,
								fontWeight: "bold",
							}}
						>
							管理コンソール
						</Typography>
					</Button>
				</Box>

				<Box sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
					<UserMenu />
				</Box>
			</Toolbar>
		</AppBar>
	);
}
